import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import slugme from "slugme";
import "./FormationItem.scss";
import Strings from "../../translations/translations";
import { saveGoBackPage } from "../../utils/history";

export class FormationItem extends Component {
  static propTypes = {
    brand: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    time: PropTypes.number,
    points: PropTypes.number,
    idFormation: PropTypes.number,
    pourcent: PropTypes.number,
  };

  render() {
    let { brand, image, title, time, points, idFormation, pourcent } =
      this.props;

    const formationSlug = slugme(this.props.title) + "-" + idFormation;
    const courseTranslation = Strings("course");

    let style = {
      backgroundImage: "url(" + image + ")",
    };

    let progressBar = {
      width: pourcent + "%",
    };
    return (
      <Link
        to={{
          pathname: "/formations/" + formationSlug,
          state: {
            transitionName: "slide_in",
            // prev: this.props.location.pathname,
          },
        }}
        onClick={() => saveGoBackPage(this.props.location.pathname)}
      >
        <div className="formation_item">
          <div className="formation_container" style={style}>
            <div className="formation_item-top">
              <div className="formation_points">+{points}</div>
            </div>
            <div className="formation_item-middle">
              <div className="formation_brand">{brand}</div>
              <div className="formation_title">{title}</div>
            </div>
            <div className="formation_item-bottom">
              <div className="formation_type">{courseTranslation}</div>
              <div className="time_progress">
                <div className="formation_progress">
                  <div className="progress" style={progressBar}></div>
                </div>
                <div className="formation_time">
                  <div className="time">{time}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default withRouter(FormationItem);
